import React from 'react';
import SupplierList from '../modules/supplier-assessment/SupplierList';

export default function SupplierAssessmentSuppliers() {
  return <SupplierList />;
}
